import styled from 'styled-components'

export const CompletedText = styled.div`
  color: #455456;
  font-size: 18px;
  text-transform: uppercase;
`
